import type { IMessageTemplateSchema } from '../schemas/message-template.schema'

export const MessageTemplateTypes = {
  REQUEST: 'request',
  BLOCKED: 'blocked',
  PENDING: 'pending',
  FINISHED: 'finished',
} as const

export type MessageTemplateType =
  (typeof MessageTemplateTypes)[keyof typeof MessageTemplateTypes]

export const messageTemplateTypes = Object.values(MessageTemplateTypes)

export type MessageTemplateDefinition = {
  footer?: string | null | undefined
  subject: string
  body: string
  buttonLabel?: string | null | undefined
}

export const buildMessageTemplateDefinition = (
  messageTemplate: Pick<
    IMessageTemplateSchema,
    'subject' | 'body' | 'footer' | 'buttonLabel'
  >,
): MessageTemplateDefinition => ({
  subject: messageTemplate.subject,
  body: messageTemplate.body,
  footer: messageTemplate.footer,
  buttonLabel: messageTemplate.buttonLabel,
})

export const resolveMessageTemplateType = (
  flow: string | string[] | undefined,
): MessageTemplateType => {
  if (!flow) return MessageTemplateTypes.REQUEST
  if (Array.isArray(flow)) return MessageTemplateTypes.REQUEST

  const messageTemplateType = messageTemplateTypes.find((type) => type === flow)
  if (messageTemplateType) return messageTemplateType

  return MessageTemplateTypes.REQUEST
}
